import React, { useRef, useState } from 'react';

export default function PhotoDropZone({ onFiles, disabled, label = 'Bilder hierher ziehen oder klicken zum Auswählen' }) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const handleFiles = (fileList) => {
    const files = Array.from(fileList || []).filter((f) => f.type.startsWith('image/'));
    if (files.length) onFiles(files);
  };

  return (
    <div
      onClick={() => !disabled && inputRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setDragOver(true); }}
      onDragLeave={() => setDragOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragOver(false);
        if (disabled) return;
        handleFiles(e.dataTransfer.files);
      }}
      className={`flex flex-col items-center justify-center gap-1 border-2 border-dashed rounded-lg px-4 py-6 text-center transition-colors ${
        disabled ? 'opacity-50 cursor-not-allowed border-slate-200' :
        dragOver ? 'border-ocean-500 bg-ocean-50 cursor-pointer' : 'border-slate-300 hover:border-ocean-400 hover:bg-slate-50 cursor-pointer'
      }`}
    >
      <span className="text-2xl">📷</span>
      <p className="text-sm text-slate-600">{label}</p>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        className="hidden"
        onChange={(e) => { handleFiles(e.target.files); e.target.value = ''; }}
        disabled={disabled}
      />
    </div>
  );
}
